// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3QmPJ","header":"ClearentDisclaimer_header__2erYJ","inner":"ClearentDisclaimer_inner__15HgF"};